import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { Box, Button, Grid, Paper, makeStyles } from "@material-ui/core";
import theme from "../../theme";
import { Description, Delete } from "@material-ui/icons";

const useStyle = makeStyles((theme) => ({
  blackText: {
    color: theme.palette.black,
    padding: 0,
    margin: 0,
  },
  cardWrap: {
    padding: 10,
    backgroundColor: theme?.palette.black,
    borderWidth: 1,
    borderColor: theme.palette.primary.dark,
  },
  docIconWrap: {
    borderRadius: 8,
    height: 90,
    width: 90,
    backgroundColor: theme.palette.primary.dark,
  },
  docIcon: {
    height: 90,
    width: 90,
  },
  bin: {
    color: theme.palette.darkGray,
  },
  priceWrap: {
    display: "flex",
  },
  preOrderLabel: {
    display: 'inline-block',
    color: "yellow",
    fontSize: '14px',
    fontWeight: '600',
    padding: '2px 7px',
  },
}));

export default function CartItemCard({ item, onRemove, taxAmount,quantity,calculateItemPrice }) {
  const classes = useStyle();
  console.log("item",item)
  return (
    <Card
      style={{
        width: "100%",
        // backgroundColor: "red",
        padding: 10,
        borderRadius: 0,
        backgroundColor: theme?.palette.darkGray,
        borderBottom: `1px solid ${theme?.palette.primary.dark}`,
        borderColor: theme.palette.primary.dark,
        marginBottom: 10,
      }}
      elevation={2}
      className={classes.cardWrap}
    >
      <Grid container spacing={2}>
        <Grid item xs={2}>
          <div className={classes.docIconWrap}>
            <img src={item?.bookId?.book_cover} alt="" style={{"height" : "auto","maxWidth" : "100%"}} /> ||{" "}
            <Description className={classes.docIcon} />
          </div>
        </Grid>
        <Grid item xs={8}>
          <div>
            <h2
              style={{
                margin: 0,
                color: theme?.palette.white,
                fontSize: 18,
                textAlign: "start",
              }}
            >
              {item?.articleId?.article_title || item?.bookId?.book_title}
              {item?.bookId?.pre_order && (
          <span className={classes.preOrderLabel}>Pre-Order</span>
         )} 
            </h2>
            <div className={classes.priceWrap}>
              <p
                style={{
                  margin: 0,
                  color: theme?.palette.secondary.dark,
                  textAlign: "start",
                }}
              >
                <span
                  style={{
                    margin: 0,

                    textAlign: "start",
                    marginLeft: 8,
                  }}
                >
                  Price
                </span>
              </p>
              <p
                style={{
                  margin: 0,
                  color: theme?.palette.white,

                  textAlign: "start",
                  marginLeft: 8,
                }}
              >
                : ${" "}
                {calculateItemPrice(item).toFixed(2)}
                {/* {item?.bookOrderType === "HARDCOPY"&&quantity===null
                  ? item?.bookId?.price?.hardcover_price*quantity
                  : item?.bookOrderType === "BOTH"&&quantity===null
                  ? item?.bookId?.price?.hardcover_price +
                    item?.bookId?.price?.digital_price
                  : item?.bookOrderType==="HARDCOPY"&&quantity!==null?item?.bookId?.price?.hardcover_price*quantity: item?.bookOrderType==="BOTH"&&quantity!==null? item?.bookId?.price?.hardcover_price+item?.bookId?.price?.digital_price*quantity: item.articleId?.per_page_price *
                      item.articleId?.number_of_pages ||
                    item.bookId?.price?.digital_price} */}
              </p>
            </div>
          </div>
        </Grid>
        <Grid item xs={2}>
          <Button
            // color="primary"
            variant="contained"
            onClick={() => onRemove(item._id)}
          >
            <Delete className={classes.bin} />
          </Button>
        </Grid>
      </Grid>
    </Card>
  );
}
